/**
 * Carga diferida del mapa.
 *
 * `maplibre-gl` son 1,1 MB sin comprimir. Antes entraban en el bundle inicial y los
 * descargaba TODO EL MUNDO, incluida la mayoría que nunca abre la vista de mapa ni el panel
 * de alta de inmueble. Ahora el paquete se pide cuando el mapa se va a pintar de verdad.
 *
 * El `fallback` NO es un spinner: es el mismo marcador de posición que ya usa el mapa cuando
 * los tiles no están descargados, con la misma altura. Así la página no da un salto cuando el
 * mapa termina de llegar — y quien tenga una conexión lenta ve algo con sentido, no un hueco.
 *
 * El nombre exportado es el mismo (`PropertyMap`), de modo que las pantallas solo cambian de
 * dónde importan.
 */
import { Suspense, lazy } from 'react';
import type { PropertyMapProps } from './PropertyMap';
import styles from './PropertyMap.module.css';

const RealMap = lazy(async () => {
  const module = await import('./PropertyMap');
  return { default: module.PropertyMap };
});

function MapSkeleton({ height }: { height: number | string }) {
  return (
    <div
      className={styles.fallback}
      style={{ height: typeof height === 'number' ? `${height}px` : height }}
      role="status"
      aria-live="polite"
    >
      <div className={styles.fallbackGrid} aria-hidden="true" />
      <p className={styles.fallbackNote}>
        <span>Cargando el mapa…</span>
      </p>
    </div>
  );
}

export function PropertyMap(props: PropertyMapProps) {
  return (
    <Suspense fallback={<MapSkeleton height={props.height ?? 260} />}>
      <RealMap {...props} />
    </Suspense>
  );
}
